import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "pq_content"
};
const _hoisted_2 = {
  class: "dialog-footer lc_gxpljbt"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createBlock(_component_el_dialog, {
    "model-value": _ctx.isShowLinksDialog,
    "before-close": _ctx.handleClose,
    title: "填写共享盘链接",
    width: "380px"
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
      onClick: _cache[1] || (_cache[1] = $event => _ctx.comClick('cancel')),
      size: "small"
    }, {
      default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("取消")])),
      _: 1,
      __: [4]
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[2] || (_cache[2] = $event => _ctx.comClick('sure')),
      size: "small"
    }, {
      default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("确定")])),
      _: 1,
      __: [5]
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("label", null, "链接地址", -1)), _createVNode(_component_el_input, {
      modelValue: _ctx.data.form.remarks_vale,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.data.form.remarks_vale = $event),
      maxlength: "200",
      placeholder: "请输入",
      "show-word-limit": "",
      type: "textarea",
      resize: "none",
      autosize: {
        minRows: 5,
        maxRows: 5
      }
    }, null, 8, ["modelValue"])])]),
    _: 1
  }, 8, ["model-value", "before-close"]);
}